import * as tslib_1 from "tslib";
import { OnInit, AfterViewInit } from '@angular/core';
import { navCode } from 'src/app/shared/constants/channel.constants';
import { ProductsBiocatchEnum, StepBiocatchEnum } from 'src/app/shared/enums/biocatchContext.enum';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';
import { ChannelCommunicatorService } from 'src/app/shared/services/communicator/channel-communicator/channel-communicator.service';
import { BioCatchService } from 'src/app/shared/services/external/biocatch/biocatch.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { RequestService } from 'src/app/shared/services/request/request-onboarding.service';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';
import { OpEnum } from '../../../shared/enums/op.enum';
import { IsDec } from '../../../shared/models/fi.model';
import { AbreCuentasService } from '../../../shared/services/abre-cuentas/abre-cuentas.service';
import { CopyService } from '../../../shared/services/copies/copy.service';
import { HeaderService } from '../../../shared/services/header/header.service';
import { NavigationService } from '../../../shared/services/navigation/navigation-onboarding.service';
import { DaliService } from '@dali/tagger-ng8';
import { EVENT as EVENT_FA_LD, PAGEVIEW as PAGEVIEW_FA_LD, CHANNEL as CHANNEL_FA_LD, COUNTRY as COUNTRY_FA_LD, BUSINNESS as BUSINNESS_FA_LD, ENVIRONMENT as ENVIRONMENT_FA_LD, FAMILY as FAMILY_FA_LD, SUBFAMILY as SUBFAMILY_FA_LD, PRODUCT as PRODUCT_FA_LD, } from 'src/app/shared/constants/dali-fa-ld.constants';
import { FirmlyApprovedService } from 'src/app/shared/services/firmly-approved/firmly-approved.service';
var InsurabilityComponent = /** @class */ (function () {
    function InsurabilityComponent(copyService, bitacoraService, abreCuentasService, navigationService, headerService, taggingServices, parametersService, bioCatchService, requestService, channelCommunicatorService, firmlyApprovedService, daliService) {
        this.copyService = copyService;
        this.bitacoraService = bitacoraService;
        this.abreCuentasService = abreCuentasService;
        this.navigationService = navigationService;
        this.headerService = headerService;
        this.taggingServices = taggingServices;
        this.parametersService = parametersService;
        this.bioCatchService = bioCatchService;
        this.requestService = requestService;
        this.channelCommunicatorService = channelCommunicatorService;
        this.firmlyApprovedService = firmlyApprovedService;
        this.daliService = daliService;
        /**
         * Objeto de tipo IsDec
         *
         * *IsDec object*
         * @access public
         * @type {IsDec}
         */
        this.IsDec = new IsDec();
        /**
         * Valida si el modal esta habilitado o no
         *
         * *Validates if the modal is enabled or not*
         */
        this.showModal = false;
        /**
         * Copies de los labels del modal
         *
         * *Labels modal copies*
         *
         * @access public
         * @type {Object}
         */
        this.buttonLabelsModal = {};
        /**
         * Valida si el botón esta habilitado o no
         *
         * *Validates if the button is enabled or not*
         */
        this.isBtnDisabled = true;
        this.headerService.show(true, true, true);
        this.documentDec = false;
    }
    InsurabilityComponent.prototype.ngOnInit = function () {
        this.sendTagging('init');
        this.initBioCatch();
        this.documentInfo = this.abreCuentasService.getDocumentInfo();
        if (this.taggingServices.isFirmlyAprovedMono()) {
            this.sendInsurabilityPageLoad();
        }
        var product = this.abreCuentasService.getproductSelected().product_code;
        if (product !== ProductsBiocatchEnum.LOA) {
            this.bioCatchService.changeContext(StepBiocatchEnum.captura, product, false, true);
        }
        this.listIsInsurability = [{
                label: this.copyService.copies.insurability_yes,
                elementId: 1,
                checked: false,
                value: true,
            },
            {
                label: this.copyService.copies.insurability_no,
                elementId: 2,
                checked: false,
                value: false,
            }];
        var insurabilityData = this.parametersService.getSetting(OpEnum.DATA_DECLARATION_INSURABILITY)[0];
        this.declaration = {
            text: insurabilityData.description,
            title: insurabilityData.code,
            declaration_id: insurabilityData.id,
        };
        this.checkboxDeclaration = {
            id: this.declaration.declaration_id,
            label: 'Manifiesto que he leído y acepto firmar la ',
            checked: false,
            value: this.declaration.declaration_id,
        };
        this.buttonLabelsModal = {
            primary: this.copyService.copies.insurability_modal_button_primary,
        };
    };
    InsurabilityComponent.prototype.ngAfterViewInit = function () {
        this.checkSelection();
    };
    InsurabilityComponent.prototype.next = function () {
        this.sendTagging('next', 'center', '2');
        console.log('identification - NextStep()');
        var bitacoraEvent1 = 'fingersPrintScan_succes';
        this.bitacoraService.saveDataInBitacora(bitacoraEvent1);
        if (this.taggingServices.isFirmlyAprovedMono()) {
            this.sendContinueButtonEvent();
        }
        this.nextCode = this.IsDec.elementId === 1 ? navCode[301] : navCode[200];
        var productSelected = this.abreCuentasService.getproductSelected();
        var bitacoraEvent = "insurability_" + productSelected.product_code;
        if (this.nextCode === navCode[200]) {
            this.bitacoraService.saveDataInBitacora(bitacoraEvent);
        }
        else {
            this.abreCuentasService.caseInfoError(this.nextCode);
        }
        this.navigationService.nextStep(this.nextCode);
        this.abreCuentasService.setInsurability(true);
    };
    InsurabilityComponent.prototype.modalAction = function (event) {
        if (event.type === 'primary') {
            this.showModal = !this.showModal;
        }
    };
    InsurabilityComponent.prototype.toggleModal = function () {
        this.showModal = !this.showModal;
    };
    InsurabilityComponent.prototype.checkboxChange = function (event) {
        this.checkboxDeclaration.checked = event.checked;
        this.abreCuentasService.setFiProperty('checkboxDeclaration', this.checkboxDeclaration);
        this.enableNextButton();
    };
    InsurabilityComponent.prototype.enableNextButton = function () {
        this.isBtnDisabled = !(this.abreCuentasService.getFiProperty('checkboxDeclaration').checked);
    };
    InsurabilityComponent.prototype.selectDecInsurability = function (event) {
        if (event.target.value === 'true') {
            this.IsDec = {
                elementId: 2,
                value: event.target.value,
                checked: true,
            };
            this.documentDec = true;
            this.enableNextButton();
        }
        else {
            this.documentDec = false;
            this.isBtnDisabled = false;
            this.IsDec = {
                elementId: 1,
                value: event.target.value,
                checked: false,
            };
        }
    };
    InsurabilityComponent.prototype.downloadPdf = function () {
        this.channelCommunicatorService.getImpl().openPdf(this.parametersService.getSetting(OpEnum.DATA_POLICY_ENDOSERD)[0].pdfUrl);
    };
    InsurabilityComponent.prototype.initBioCatch = function () {
        var product = this.abreCuentasService.getproductSelected().product_code;
        this.bioCatchService.changeContext(StepBiocatchEnum.captura, product);
    };
    InsurabilityComponent.prototype.checkSelection = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.isInsurability = this.abreCuentasService.getInsurability();
                if (this.isInsurability) {
                    this.listIsInsurability[0].checked = true;
                    this.selectDecInsurability({ target: { value: 'true' } });
                    this.checkboxDeclaration.checked = this.isInsurability;
                    this.abreCuentasService.setFiProperty('checkboxDeclaration', this.checkboxDeclaration);
                    this.enableNextButton();
                }
                return [2 /*return*/];
            });
        });
    };
    /* ------------- Taggeo ------------- */
    /* ------------ Taggeo - PageLoad ------------ */
    InsurabilityComponent.prototype.sendInsurabilityPageLoad = function () {
        var isApp = this.channelCommunicatorService.getChannelId() === '141';
        var changes = [
            {
                path: PAGEVIEW_FA_LD.pv3pageName.path,
                value: (isApp ? CHANNEL_FA_LD.superapp : CHANNEL_FA_LD.homeBanking) + ":" + COUNTRY_FA_LD.co + ":" + BUSINNESS_FA_LD.pf + ":" + ENVIRONMENT_FA_LD.loggeado + ":" + FAMILY_FA_LD.services + ":" + SUBFAMILY_FA_LD.request + ":" + PRODUCT_FA_LD.request + ":" + PAGEVIEW_FA_LD.pv3pageName.value,
            },
            {
                path: PAGEVIEW_FA_LD.pv3pageFamily.path,
                value: PAGEVIEW_FA_LD.pv3pageFamily.value,
            },
            {
                path: PAGEVIEW_FA_LD.pv3subFamily.path,
                value: PAGEVIEW_FA_LD.pv3subFamily.value,
            },
            {
                path: PAGEVIEW_FA_LD.pv3pageAction.path,
                value: PAGEVIEW_FA_LD.pv3pageAction.value,
            },
            {
                path: PAGEVIEW_FA_LD.pv3pageid.path,
                value: InsurabilityComponent.name,
            },
            {
                path: PAGEVIEW_FA_LD.pv3transactionName.path,
                value: "" + PAGEVIEW_FA_LD.pv1transactionName.value.slice(0, -2) + this.taggingServices.getProductFlow(),
            },
            {
                path: PAGEVIEW_FA_LD.pv3transactionTransactionStep.path,
                value: PAGEVIEW_FA_LD.pv3transactionTransactionStep.value,
            },
        ];
        this.taggingServices.addCommonPageChanges(changes);
        this.daliService.pageLoad(changes);
    };
    /* -------------- Taggeo - Events ------------- */
    InsurabilityComponent.prototype.sendBackButtonEvent = function () {
        this.sendTagging('prev', 'center', '1');
        if (!this.taggingServices.isFirmlyAprovedMono()) {
            return;
        }
        var data = [
            {
                path: EVENT_FA_LD.pv3E1setData.pv3E1transactionTransactionStep.path,
                value: EVENT_FA_LD.pv3E1setData.pv3E1transactionTransactionStep.value,
            },
            {
                path: EVENT_FA_LD.pv3E1setData.pv3E1transactionName.path,
                value: "" + PAGEVIEW_FA_LD.pv1transactionName.value.slice(0, -2) + this.taggingServices.getProductFlow(),
            },
        ];
        var event = {
            category: {
                module: EVENT_FA_LD.customCategory.module.body,
                type: EVENT_FA_LD.customCategory.type.button,
                position: EVENT_FA_LD.customCategory.position.center,
            },
            action: EVENT_FA_LD.customAction.click,
            label: EVENT_FA_LD.pv3E1customLabel,
        };
        this.daliService.trackEvent(event, data);
    };
    InsurabilityComponent.prototype.sendContinueButtonEvent = function () {
        var data = [
            {
                path: EVENT_FA_LD.pv3E2setData.pv3E2transactionTransactionStep.path,
                value: EVENT_FA_LD.pv3E2setData.pv3E2transactionTransactionStep.value,
            },
            {
                path: EVENT_FA_LD.pv3E2setData.pv3E2transactionName.path,
                value: "" + PAGEVIEW_FA_LD.pv1transactionName.value.slice(0, -2) + this.taggingServices.getProductFlow(),
            },
        ];
        var event = {
            category: {
                module: EVENT_FA_LD.customCategory.module.body,
                type: EVENT_FA_LD.customCategory.type.button,
                position: EVENT_FA_LD.customCategory.position.center,
            },
            action: EVENT_FA_LD.customAction.click,
            label: EVENT_FA_LD.pv3E2customLabel,
        };
        this.daliService.trackEvent(event, data);
    };
    InsurabilityComponent.prototype.sendTagging = function (value, position, event) {
        var page = '4';
        var extras = {
            object: 'clientElegibility',
            value: this.IsDec.checked ? 'Si' : 'No',
            pageValue: 'Insurability',
        };
        this.taggingServices.sendTaggValues(value, page, position, event, extras);
    };
    return InsurabilityComponent;
}());
export { InsurabilityComponent };
